import { useEffect } from "react"

import { Button, DefaultTooltip, Badge } from "twyne-new.ui"

import { useTcpaConsentDbaContext } from "./Context"

export default function TcpaConsentDbaTriggerButton({ tcpaConsentText, tcpaConsentDba }) {
  const { setTcpaConsentDbaContextValue } = useTcpaConsentDbaContext()

  const handleClick = () => {
    setTcpaConsentDbaContextValue(prevState => ({ ...prevState, open: true }))
  }

  useEffect(() => {
    setTcpaConsentDbaContextValue(prevState => ({ ...prevState, tcpaConsentText, tcpaConsentDba }))
  }, [tcpaConsentText, tcpaConsentDba, setTcpaConsentDbaContextValue])

  return <div className='flex items-center gap-1'>
    <Button color='accent' size='sm' variant='ghost' onClick={handleClick}>
      Configure Consent DBA
    </Button>
    {tcpaConsentDba && tcpaConsentDba.length > 0 && <>
      <DefaultTooltip content='Current number of configured DBAs'>
        <Badge color='accent'>
          {tcpaConsentDba.length}
        </Badge>
      </DefaultTooltip>
    </>}
  </div>
}
